module.exports = __webpack_public_path__ + "img/reels.f95fa25e.svg";